import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Row,
  Col,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  APIgetAdminOnlineUsers,
  APIgetAdminOverview,
} from '../../api/Admin';

import LoadingSmall from '../../components/LoadingSmall';

const AdminPanelOverview = ({ period }) => {
  const [stats, setStats] = useState(null);
  const [online, setOnline] = useState(null);
  const [statsLoading, setStatsLoading] = useState(true);
  const [onlineLoading, setOnlineLoading] = useState(true);

  const intl = useIntl();

  const fetchOverview = useCallback(() => {
    APIgetAdminOverview({ period }).then((response) => {
      setStats(response.data);
      setStatsLoading(false);
    });
  }, [period]);

  const fetchOnline = useCallback(() => {
    APIgetAdminOnlineUsers().then((response) => {
      setOnline(response.data);
      setOnlineLoading(false);
    });
  }, []);

  useEffect(() => {
    fetchOverview();
    fetchOnline();
  }, [fetchOverview, fetchOnline]);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchOverview();
    }, 60 * 1000);
    return () => clearInterval(interval);
  }, [fetchOverview]);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchOnline();
    }, 10 * 1000);
    return () => clearInterval(interval);
  }, [fetchOnline]);

  return (
    <div className="widget widget-stats-overview">
      <Row>
        <Col xs="12" sm="6" xl="3" className="widget-stat-overview widget-stat-all-clients">
          <div className="widget-stat">
            <span>{intl.formatMessage({ defaultMessage: 'Accounts' })}</span>
            <div className="stats-number">
              {statsLoading ? (
                <LoadingSmall />
              ) : (
                stats.clients
              )}
            </div>
          </div>
        </Col>
        <Col xs="12" sm="6" xl="3" className="widget-stat-overview widget-stat-all-users">
          <div className="widget-stat">
            <span>{intl.formatMessage({ defaultMessage: 'Users' })}</span>
            <div className="stats-number">
              {statsLoading ? (
                <LoadingSmall />
              ) : (
                stats.users.all
              )}
            </div>
          </div>
        </Col>
        <Col xs="12" sm="6" xl="3" className="widget-stat-overview widget-stat-activated-users">
          <div className="widget-stat">
            <span>{intl.formatMessage({ defaultMessage: 'Activated users' })}</span>
            <div className="stats-number">
              {statsLoading ? (
                <LoadingSmall />
              ) : (
                stats.users.activated
              )}
            </div>
          </div>
        </Col>
        <Col xs="12" sm="6" xl="3" className="widget-stat-overview widget-stat-online-users">
          <div className="widget-stat">
            <div>
              <span>{intl.formatMessage({ defaultMessage: 'Online users' })}</span>
              <Link to="/online">
                <i className="fa-solid fa-arrow-right" />
              </Link>
            </div>
            <div className="stats-number">
              {onlineLoading ? (
                <LoadingSmall />
              ) : (
                online.users_count
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

AdminPanelOverview.propTypes = {
  period: PropTypes.string.isRequired,
};

export default AdminPanelOverview;
